import { User } from "../../services/userService";
import { Button } from "../ui/Button";
import { Card } from "../ui/Card";
import { Pencil, Trash2, CalendarClock } from "lucide-react";

interface StudentInfoCardProps {
  student: User;
  onEdit: () => void;
  onDelete: () => void;
  onExtend?: () => void;
}

export function StudentInfoCard({
  student,
  onEdit,
  onDelete,
  onExtend,
}: StudentInfoCardProps) {
  // Format last login date
  const lastLogin = student.lastLogin
    ? new Date(student.lastLogin).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "Never";

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <h2 className="text-xl font-bold text-gray-900">1. Basic info</h2>
        <div className="flex w-full sm:w-auto gap-3">
          {onExtend && (
            <Button
              variant="primary"
              onClick={onExtend}
              className="flex-1 sm:flex-none gap-2"
            >
              <CalendarClock className="h-4 w-4" />
              Extend Courses
            </Button>
          )}
          <Button
            variant="outline"
            onClick={onEdit}
            className="flex-1 sm:flex-none gap-2"
          >
            <Pencil className="h-4 w-4" />
            Edit
          </Button>
          <Button
            variant="outline"
            onClick={onDelete}
            className="flex-1 sm:flex-none gap-2 text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700"
          >
            <Trash2 className="h-4 w-4" />
            Delete
          </Button>
        </div>
      </div>

      <Card className="p-4 sm:p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-500">
              Student name
            </label>
            <div className="p-3 bg-gray-50 rounded-md border border-gray-100 text-gray-900">
              {student.firstName} {student.lastName}
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-500">Email</label>
            <div className="p-3 bg-gray-50 rounded-md border border-gray-100 text-gray-900">
              {student.email}
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-500">
              Last Login
            </label>
            <div className="p-3 bg-gray-50 rounded-md border border-gray-100 text-gray-900">
              {lastLogin}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
